export class DeleteLayerIN {
    idCentrale: number
    storage: string
    workspace: string
}
